export default "__VITE_PUBLIC_ASSET__0c04c107__"